import React, { useMemo } from 'react';
import {
    FormControl,
    InputLabel,
    MenuItem,
    Select,
} from '@mui/material';
import { useFormContext } from 'react-hook-form'; // or from 'react-hook-form'



const SelectTestUser = () => {
    const { setValue } = useFormContext();

    // Memoize the credentials to avoid parsing JSON on every render
    const testCredentials = useMemo(() => {
        try {
            const storedCredentials = localStorage.getItem('testCredentials');
            if (!storedCredentials) {
                return null;
            }
            return JSON.parse(storedCredentials);
        } catch (error) {
            console.warn('Failed to parse test credentials from localStorage:', error);
            return null;
        }
    }, []); // Empty dependency array since localStorage should be stable

    // Memoize the change handler to prevent recreation on every render
    const handleChange = React.useCallback(event => {
        const selectedLabel = event.target.value;
        const user = testCredentials?.find(u => u.label === selectedLabel);
        if (!user) return;

        // Update the form fields
        setValue('username', user.username);
        setValue('password', user.password);
        setValue('role', user.role);
    }, [testCredentials, setValue]);

    // Early return if no credentials
    if (!testCredentials || !Array.isArray(testCredentials) || testCredentials.length === 0) {
        return null;
    }

    return (
        <FormControl fullWidth>
            <InputLabel>Select a test user</InputLabel>
            <Select label="Select a test user" onChange={handleChange}>
                {testCredentials.map(cred => (
                    <MenuItem key={cred.label} value={cred.label}>
                        {cred.label}
                    </MenuItem>
                ))}
            </Select>
        </FormControl>
    );
};

export default SelectTestUser;
